import React from 'react'
import { Block, Cta } from '@components'

const DatoCmsCta = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Cta {...props} />
    </Block>
  )
}

export default DatoCmsCta
